import IntlMessageFormat from 'intl-messageformat';
import createFormatCache from 'intl-format-cache';
import dictionary from './dictionary';

const getMessageFormat = createFormatCache(IntlMessageFormat);

/**
 * Recursively resolve a key in the dictionary
 */
const getFinalMessage = (key, count = 0) => {
  if (count > 5) {
      throw new Error(`Mutually referencing dictionary key: ${key}`);
  }
  const message = dictionary[key];
  return !message ? key : getFinalMessage(message, ++count);
}

/**
 * Returns {true} if dictionary contains message for `key`
 */
export const hasMessage = key => key in dictionary;

/**
 * Translate a key to a message
 */
export const translate = (key, values, fallback = null) => {
  !key && console.warn('Translate called with no key');

  let message = getFinalMessage(key);

  if (message === key) {
    message = fallback || key;
  }

  if (!message) { return null; }

  return typeof message === 'string'
    ? getMessageFormat(message).format(values)
    : message;
};

export default translate;
